import { apiGet, apiPost } from "./apiClient";

// The accounting system the portal shows. It is a global setting on the API,
// not a per-user preference: one admin flips it, everyone sees the same source.
// It is separate from the Intuit ingestion toggle — the switch changes the view,
// not what is being synced.

export type SourceInfo = {
  source: string;
  options: string[];
  labels?: Record<string, string>;
};

export async function getSource(): Promise<SourceInfo> {
  return apiGet({ endpoint: "/admin/source", withAuth: true });
}

export async function setSource(source: string): Promise<{ message: string; source: string }> {
  return apiPost({ endpoint: "/admin/source", data: { source }, withAuth: true });
}
